import ApplicantPaymentModalContainer from "./ApplicantPaymentModalContainer";

export default ApplicantPaymentModalContainer;
